export default "__VITE_ASSET__7EdNAdx1__"